import React, { ReactElement } from 'react';

import Icon from 'atomic/icon/icon';

import './company-view-best-offers-nav.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CompanyViewBestOffersNav: React.FC<any> = ({ next, previous, carouselState }): ReactElement => {
    const showPrevButton = carouselState.currentSlide > 0;
    const showNextButton = (carouselState.currentSlide + 1) * carouselState.slidesToShow < carouselState.totalItems;

    const productBestOfferEvent = {
        event: 'productBestOffer',
        eventCategory: '',
        eventAction: 'widgetClickPrevButton',
        eventLabel: ''
    };

    const handleClickPrev = (): void => {
        window.dataLayer.push({
            ...productBestOfferEvent,
            eventAction: 'widgetClickPrevButton'
        });

        previous();
    };

    const handleClickNext = (): void => {
        window.dataLayer.push({
            ...productBestOfferEvent,
            eventAction: 'widgetClickNextButton'
        });

        next();
    };

    return (
        <div className="best-offers__nav">
            {showPrevButton && (
                <button type="button" className="best-offers__nav-item best-offers__nav-item--left" onClick={handleClickPrev}>
                    <Icon icon="chevron-left" />
                </button>
            )}
            {showNextButton && (
                <button type="button" className="best-offers__nav-item best-offers__nav-item--right" onClick={handleClickNext}>
                    <Icon icon="chevron-right" />
                </button>
            )}
        </div>
    );
};

export default CompanyViewBestOffersNav;
